import React from 'react';
import { artavaBrand } from '../../branding/artavaBrand';

export default function DashboardSidebar({
  isOpen,
  onToggleSidebar,
  onNavigate,
  onLogout,
  onToggleLanguage,
  currentLanguage,
  onUpdateApp,
  updateStatus,
  isUpdatingApp,
  currentUser,
  styles,
  t,
}) {
  const nextLanguageLabel = currentLanguage === 'en' ? 'IT' : 'EN';

  return (
    <div className={`${styles.dashboardSidebar} ${isOpen ? '' : styles.closed} ${styles.sidebarAnimation}`}>
      <div className={styles.sidebarMenu}>
        <a
          href={artavaBrand.websiteUrl}
          target="_blank"
          rel="noreferrer"
          className={styles.sidebarBrandingLink}
        >
          <img
            src={artavaBrand.logoSrc}
            alt={artavaBrand.companyName}
            className={styles.sidebarBrandingLogo}
          />
          <div className={styles.sidebarBrandingText}>
            <span>{t('Built By Artava Systems')}</span>
            <strong>{artavaBrand.websiteHost}</strong>
          </div>
        </a>
        <button
          type="button"
          onClick={onToggleSidebar}
          className={styles.sidebarToggle}
          aria-label={isOpen ? t('Hide sidebar') : t('Show sidebar')}
        >
          {isOpen ? t('Hide sidebar') : t('Show sidebar')}
        </button>
        <button
          type="button"
          onClick={onToggleLanguage}
          className={styles.languageToggle}
          aria-label={t('Change Language')}
        >
          <span>{t('Language')}</span>
          <strong>{currentLanguage?.toUpperCase()} / {nextLanguageLabel}</strong>
        </button>

        <button onClick={() => onNavigate('/production-dashboard')} className={`${styles.menuItem} ${styles.active}`}>{t('Dashboard')}</button>
        <button onClick={() => onNavigate('/dashboard')} className={styles.menuItem}>{t('Choose Dashboard')}</button>
        <button onClick={() => onNavigate('/upload')} className={styles.menuItem}>{t('Upload New Files')}</button>
        <button onClick={() => onNavigate('/file-table')} className={styles.menuItem}>{t('View All Files')}</button>
        <button onClick={() => onNavigate('/uut-status-summary')} className={styles.menuItem}>{t('UUT Status Summary')}</button>
        <button onClick={() => onNavigate('/pie-chart')} className={styles.menuItem}>{t('Pie Chart Analysis')}</button>
        <button onClick={() => onNavigate('/pareto-chart')} className={styles.menuItem}>{t('Pareto Chart Analysis')}</button>
        <button onClick={() => onNavigate('/control-chart')} className={styles.menuItem}>{t('Control Chart Analysis')}</button>
        <button onClick={() => onNavigate('/root-cause-prediction')} className={styles.menuItem}>Failure Link</button>
        <button onClick={() => onNavigate('/step-frequency')} className={styles.menuItem}>{t('Step Frequency Analyzer')}</button>
        <button onClick={() => onNavigate('/root-cause-alarms')} className={styles.menuItem}>{t('Root Cause Alarms')}</button>
        <button onClick={() => onNavigate('/ml/runs')} className={styles.menuItem}>{t('ML Runs')}</button>
        <button onClick={() => onNavigate('/normal-distribution')} className={styles.menuItem}>{t('Process Capability Report')}</button>
        <button onClick={() => onNavigate('/first-fail-fingerprint')} className={styles.menuItem}>{t('First-Fail Fingerprint')}</button>
        <button onClick={() => onNavigate('/limit-margin-risk')} className={styles.menuItem}>{t('Limit Margin Risk')}</button>
        <button onClick={() => onNavigate('/production-hotspots')} className={styles.menuItem}>{t('Production Hotspots')}</button>
        <button onClick={() => onNavigate('/cascade-failure-spread')} className={styles.menuItem}>{t('Cascade Failure Spread')}</button>
        <button onClick={() => onNavigate('/retry-pressure')} className={styles.menuItem}>{t('Retry Pressure')}</button>
        <button onClick={() => onNavigate('/late-failure-cost')} className={styles.menuItem}>{t('Late-Stage Failure Cost')}</button>
        <button onClick={onUpdateApp} className={styles.updateAppButton} disabled={isUpdatingApp}>
          {isUpdatingApp ? t('Updating App...') : t('Update App')}
        </button>
        {updateStatus && <p className={styles.updateStatus}>{updateStatus}</p>}
        <button onClick={onLogout} className={styles.Logout}>{t('Logout')}</button>
      </div>
    </div>
  );
}
